export default __webpack_public_path__ + "static/media/icon-aircraft.ac33ee1e.svg";